import auth from './auth';
import methods from './methods';

export default {...methods, ...auth }
